import { render } from "./Page403.vue?vue&type=template&id=73030290&scoped=true&ts=true"
import script from "./Page403.vue?vue&type=script&lang=ts"
export * from "./Page403.vue?vue&type=script&lang=ts"

import "./Page403.vue?vue&type=style&index=0&id=73030290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73030290"]])

export default __exports__